import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SLICE_NAMES } from '../constants';
import { ANALYTICS } from '@/constants/analytics/analytics';

interface ReconsentState {
  isModalOpen: boolean;
  activationSource: string;
}

// The banner is the only opener that doesn't name itself, so it owns the default.
const initialState: ReconsentState = {
  isModalOpen: false,
  activationSource: ANALYTICS.SOURCE.RECONSENT_BANNER,
};

const reconsentSlice = createSlice({
  name: SLICE_NAMES.RECONSENT,
  initialState,
  reducers: {
    openReconsentModal: (state, action: PayloadAction<string | undefined>) => {
      state.isModalOpen = true;
      state.activationSource =
        action.payload ?? ANALYTICS.SOURCE.RECONSENT_BANNER;
    },
    closeReconsentModal: state => {
      state.isModalOpen = false;
    },
  },
});

export const { openReconsentModal, closeReconsentModal } =
  reconsentSlice.actions;
export const reconsentReducer = reconsentSlice.reducer;
